/// <reference path="../../../../typings.d.ts" />

import { Component } from '@angular/core';
import 'file-saver';
import { NavigationStateService } from './navigation.state.service';
import { CommunicationsStateService } from '../communications/communications.state.service';
import { SettingsStateService } from '../settings/settings.state.service';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { StorageUtil } from '../../../utils/storage.util';
import * as $ from 'jquery';
import { ReportHttpService } from '../../../services/report/report.http.service';
import { DashboardHttpUtil } from '../dashboard.util';
import { AuthentificationService } from '../../../services/auth/authentification.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';

@Component({
  moduleId: module.id,
  selector: 'bft-navigation',
  templateUrl: 'navigation.component.html',
  styleUrls: ['navigation.component.css'],
  providers: []
})

export class NavigationComponent {

  tenantName = '';

  status: boolean = true;
  isHeaderIndex: boolean = false;
  currentPage = 'Главная';
  summaryStatus: boolean = false;
  chatOpenedDialogStatus: boolean = false;

  fileName = 'summary';

  accountsList = [

  ];
  account = 0;
  settings: any = {};

  constructor(
    private navigationStateService: NavigationStateService,
    private settingsStateService: SettingsStateService,
    private router: Router,
    private communicationsStateService: CommunicationsStateService,
    private reportHttpService: ReportHttpService,
    private authentificationService: AuthentificationService,
    private cookieService: CookieService) {

    this.settings = environment;
  }

  loadingUsers() {
    this.accountsList = [];

    this.authentificationService.getUsers().subscribe(success => {
      let users = success.json();
      if(users.length <= 0) {
        this.authentificationService.logout();
        this.router.navigate(['/']);
      } else {
        users.map((item, i) => {
          this.accountsList.push({
            label: item.name,
            value: (i + 1)
          });

          if (item.current == true) {
            let self = this;

            setTimeout(function () {
              self.account = (i + 1);
            }, 500);
          }
        });
      }
    });
  }

  handleChangeUser($event) {
    this.authentificationService.authForUser($event.value-1).subscribe(success => {
      if(success.url.indexOf('errorMessage') != -1 ){

      } else {
        let token = this.cookieService.get('secureToken');
        if (token) {
          AuthentificationService.saveToken(token);
        }

        let tenantName = this.cookieService.get('tenantName');
        if (tenantName) {
          StorageUtil.setTenantName(tenantName);
        }

        let tenantType = this.cookieService.get('tenantType');
        if (tenantType) {
          StorageUtil.setTenantType(tenantType);
        }

        location.reload(true);
        this.router.navigate(['/main']);
      }
      this.loadingUsers();
    }, error => {
      console.log(error);
    });
  }

  ngOnInit() {
    this.tenantName = StorageUtil.getTenantName();

    // FIXME
    if(this.router.url === '/main' || this.router.url === '/communications' ) {
      this.isHeaderIndex = true;
      this.currentPage = this.getTitlePage(this.router.url);
    }

    if(this.router.url === '/contracts') {
      this.summaryStatus = true;
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd ) {
        this.currentPage = this.getTitlePage(event.url);

        if(event.url === '/main' || event.url === '/communications') {
          this.isHeaderIndex = true;
        } else {
          this.isHeaderIndex = false;
        }

        if(event.url === '/contracts') {
          this.summaryStatus = true;
        } else {
          this.summaryStatus = false;
        }
      }
    });

    this.navigationStateService.handleNavigationStatus().subscribe(data => {
      this.status = data.status;
    });

    this.communicationsStateService.handleSetMobileClass().subscribe(data => {
      this.chatOpenedDialogStatus = data.dialogStatus;
    });

    this.loadingUsers();
  }

  ngAfterViewInit() {
    this.OpenBox({
      wrap: '#header',
      link: '.toogle-menu',
      box: '.nav-holder',
      openClass: 'open'
    });
  }

  openSettings() {
    this.settingsStateService.triggerSettingsStatus({display: true})
  }

  // FIXME
  getTitlePage(url) {
    let title;

    switch (url) {
      case '/main':
        title = 'Главная';
        break;
      case '/contracts':
        title = 'Договоры';
        break;
      case '/communications':
        title = 'Связь';
        break;
      case '/history':
        title = 'История операций';
        break;
      case '/notifications':
        title = 'История уведомлений';
        break;
      case '/personal':
        title = 'Профиль арендатора';
        break;
      default:
        title = 'Главная';
        break;
    }

    return title;

  }

  downloadSummary($event) {
    $event.preventDefault();

    let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    this.reportHttpService.getSummary(requestParams)
      .map(res => {
        if(res.headers.get('content-disposition')) {
          this.fileName = res.headers.get('content-disposition').split('"')[1];
          return res.blob();
        }
      })
      .subscribe(
        blobContent => {
          if(blobContent) {
            saveAs(blobContent, this.fileName);
          } else {
          }
        },
        error => {
        },
        () => {
        });
  }

  OpenBox(obj) {
    $(obj.wrap).each(function(){
      let hold = $(this);
      let link = hold.find(obj.link);
      let box = hold.find(obj.box);
      let w = obj.w;
      let close = hold.find(obj.close);

      link.click(function(){
        $(obj.wrap).not(hold).removeClass(obj.openClass);
        if (!hold.hasClass(obj.openClass)) {
          hold.addClass(obj.openClass);
        }
        else {
          hold.removeClass(obj.openClass);
        }
        return false;
      });


      $("body").click(function(){
        if (!hold.hasClass('hovering')) {
          hold.removeClass(obj.openClass);
        }
      });
      close.click(function(){
        hold.removeClass(obj.openClass);

        return false;
      });
    });
  }

  setLogoStyle() {
      return {
        'background': 'url(' + this.settings.site.logo_url +') no-repeat 50% 0'
      };
  }

  logout(): void {
    this.cookieService.deleteAll();
    this.authentificationService.logout().subscribe(
      (data) => {
          this.router.navigate(['/']);
      },
      (error) => {
      console.log(error)
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/navigation/navigation.component.ts